import { useState, useEffect } from "react"

import { logout } from "../../auth"
import { useNavigate } from "react-router-dom"
import { get } from '../../services/api';

import NotifierPopup from "../../components/NotifierPopup/NotifierPopup";
import ModalGerenciaAnimal from "../../components/ModalGerenciaAnimal/ModalGerenciaAnimal"
import Filtros from "../../components/FiltrosGerenciaAnimais/FiltrosGerenciaAnimais"
import Metas from "../../components/Metas/Metas"


function AnimaisConsultaAdm() {
    const navigate = useNavigate(); 

    const [ filtros, setFiltros ] = useState({   
            idfiliais: null, 
            id_tipo_metas: null,
            mes: null, 
            ano: null 
        })
    const [ metas, setMetas ] = useState([])
    const [ authTokenState, setAuthToken ] = useState(null)

    const [ mesAtual, setMesAtual ] = useState(null)
    const [ anoAtual, setAnoAtual ] = useState(null)

    const [ showModalGerenciaAnimal, setShowModalGerenciaAnimal ] = useState(false)
    const [ managingAnimalMetas, setManagingAnimalMetas ] = useState({})

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    })
    
    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey])
                    return accumulator + `&${paramKey}=${object[paramKey]}`
                else return accumulator
            }, '')
    }

    async function setMetasWithRequest() {
        try {
            const metas = await get(`/admin/metas?${parseObjectToURLQuery(filtros)}`, null, authTokenState)
            setMetas(metas[0].animais)

            return metas[0].animais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }
        setAuthToken(authToken)
    }, [])

    return (
        <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        {showModalGerenciaAnimal && 
            <ModalGerenciaAnimal 
                metas={managingAnimalMetas} 
                ano={anoAtual}
                mes={mesAtual}
                authToken={authTokenState} 
                hideModalGerenciaAnimal={() => { 
                    setShowModalGerenciaAnimal(false) 
                }} 
                setNotifier = {(isSuccess, message) => setNotify({
                    isActive: true,
                    isSuccessful: isSuccess,
                    message: message
                })}
                refetchMetas={() => 
                    setMetasWithRequest() 
                } 
        />}
        <div className="manage-animais-wrapper">
            <Filtros filtros={filtros} setFiltros={setFiltros} setMetas={setMetas} refetchMetas={() => setMetasWithRequest() } />
            <Metas metas={metas} filtros={filtros} manageAnimal={async (id_animal, ano, mes) => {
                const newMetas = await setMetasWithRequest()

                setManagingAnimalMetas(newMetas.find(meta => meta.id_animal === id_animal))
                setShowModalGerenciaAnimal(true)
                setAnoAtual(ano)
                setMesAtual(mes)
            }} />
        </div>
        </>
    )
}

export default AnimaisConsultaAdm